import { catalogueApi, inventoryApi, numberPoolApi } from '@/helpers/apis';
import axios from '@/helpers/axios';
import { getPayloadParams } from '@/helpers/common';
import { IGetServiceNumber, IRequestData } from './models/CatalogueModel';

export const getPricePlanGroup = (requestData: IRequestData) => {
  const url = catalogueApi.GET_PRICEPLAN_GROUP;
  return axios.post(url, requestData);
};

export const getMobileShareLines = () => {
  const url = catalogueApi.GET_MOBILE_SHARE_PARENT_LINES;
  return axios.get(url);
};

export const getMobileShareEligibility = (requestData) => {
  const url = catalogueApi.GET_MOBILE_SHARE_ELIGIBILITY;
  return axios.post(url, requestData);
};

export const getPlanByType = (requestData) => {
  const url = `${catalogueApi.GET_MOBILE_SHARE_PLANS}/${requestData.msaHeaderId}/${requestData.planType}`;
  return axios.get(url);
};

export const getPricePlanAssociation = (requestData: IRequestData) => {
  const url = catalogueApi.GET_PRICEPLAN_ASSOCIATIONS;
  return axios.post(url, requestData);
};

export const getAddonGroup = (msaHeaderId: string, brn, transactionType, email, hasBom = false, pricePlanId = '') => {
  const url = catalogueApi.GET_ADDONS_GROUP;
  return axios.post(url, { msaHeaderId, brn, transactionType, email, hasBom, pricePlanId });
};

export const getEquipmentDetails = (payload: any) => {
  const url = catalogueApi.GET_EQUIPMENT_VARIANT;
  return axios.post(url, payload);
};

export const getServiceNumber = (requestData: IGetServiceNumber) => {
  const url = inventoryApi.GET_SERVICE_NUMBERS;
  return axios.post(url, requestData);
};

export const getDeviceBrands = () => {
  const url = catalogueApi.GET_DEVICE_BRAND;
  return axios.get(url);
};

export const getDeviceByPlanGroup = (page: number, size: number, reqData) => {
  const url = `${catalogueApi.GET_DEVICE_BY_PLANGROUP}?page=${page.toString()}&size=${size.toString()}`;
  return axios.post(url, { ...reqData });
};

export const getSmartTemplateListDetails = (reqData) => {
  const url = `${catalogueApi.GET_SMART_TEMPLATE_DETAILS}?${getPayloadParams(reqData)}`;
  return axios.get(url);
};

export const editSmartTemplateName = (reqData) => {
  const url = `${catalogueApi.UPDATE_SMART_TEMPLATE_NAME}`;
  return axios.post(url, reqData);
};

export const deleteSmartTemplate = (templateId) => {
  const url = `${catalogueApi.DELETE_SMART_TEMPLATE}/${templateId}`;
  return axios.post(url);
};

export const getSmartTemplateById = (templateId) => {
  const url = `${catalogueApi.GET_SMART_TEMPLATE_BY_ID}/${templateId}`;
  return axios.get(url);
};

export const getDeviceCheckReserve = () => {
  const url = catalogueApi.GET_CHECK_RESERVE;
  return axios.get(url);
};

export const getReservedStocksVariant = (payload) => {
  const url = catalogueApi.GET_RESERVED_STOCKS;
  return axios.post(url, payload);
};

export const getNumberPoolBillingAccounts = ({ payload }) => {
  const url = numberPoolApi.NUMBER_POOL_BILLING_ACCOUNTS;
  return axios.post(url, payload);
};

export const getNumberPoolSelectedBillAcc = ({ payload }) => {
  const url = numberPoolApi.NUMBER_POOL_CHECKOUT_BILLING_ACCOUNTS;
  return axios.post(url, payload);
};

export const getBundledAddonsForPriceplan = (msaHeaderId, data) => {
  const payload = {
    msaHeaderId: msaHeaderId,
    pricePlanList: [data]
  }
  const url = catalogueApi.ADDON_BY_PRICEPLAN;
  return axios.post(url, payload);
};

export const getDepResellerBrnIds = () =>{
  return axios.get(catalogueApi.DEP_RESELLER_BRN_ID);
}